/* eslint-disable */
import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain'

import { attachComponent } from '../implementation.js'

export const roundTopComponents = [
  attachComponent
    .withComponent(violationsComponent, 'default', true)
    .withEntity('RoundTop')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.$violations],
        $violations => ({
          violations: $violations,
        })
      )
    ),
]
